export const UPDATE_KITCHEN_TICKET = 'providers/settings/KitchenTicket/UPDATE_KITCHEN_TICKET';
export const GET_KITCHEN_TICKET = 'providers/settings/KitchenTicket/GET_KITCHEN_TICKET';
